<template>
    <div>
        <compWrapper title="基本信息" theme="primary">
            <compFormQuery
                v-if="type=='query'"
                class="margin-top-15 margin-right-15"
                :formdata="getBase"
                :value="formData"
                :labelWidth="120"
            ></compFormQuery>
            <compFormEdit
                v-else
                class="margin-top-15 margin-right-15"
                ref="editform"
                :formdata="getBase"
                v-model="formData"
                :labelWidth="120"
            />
        </compWrapper>
        <div class="text-right" v-show="type =='add' && nextshow">
            <vButton theme="primary" @click="submit('addtype')">下一步</vButton>
        </div>
        <!-- 添加仓库 -->
        <compWrapper title="成本组仓库列表" theme="info" v-if="showwarehouse">
            <div class="margin-top-20 margin-left-15" v-if="type!='query'">
                <span>仓库名称：</span>
                <vSelect style="width:400px;display: inline-block;" v-model="warehouseName" filterable clearable>
                    <vOption v-for="(item,index) in getNewWarehouseCodeList" :value="item.value" :key="index">{{item.label}}</vOption>
                </vSelect> 
                <vButton @click="addWarehouse(warehouseName)">添加成本组仓库</vButton>
            </div>
            <compTablelist class="margin-layout" :columns="columns" v-bind="getCostWarehouseList" ref="refwarehosue"></compTablelist>
        </compWrapper>
        <!-- 操作历史 -->
        <compWrapper title="操作历史" theme="gray" v-if="type=='query'">
            <compLog :data="logList" ></compLog>
        </compWrapper>
        <div v-if="type!='query' && editshow" class="text-right margin-top-10">
            <vButton theme="primary" @click="submit">保存</vButton>
            <vButton class="margin-left-10" @click="close">返回</vButton>
        </div>
        <!-- 添加全局的liading -->
        <vLoading size="large" transfer fix :loading="loading"></vLoading>
    </div>
</template>

<script>
import { mapState,mapGetters } from "vuex";
import { HttpGetCostGroupOne,HttpSaveCostGroupOne,HttpGetCostGroupNameList,HttpDeleteWarehouseOne,HttpAddWarehouseOne,HttpGetWarehouseList } from "@/service/boss/cost";
import { HttpSysOpLog } from '@/service/boss/allot';
export default {
    props:['activeid','querytype'],
    components: {
		compWrapper: () => import("@components/templates/wrapper"),
		compFormQuery: () => import("@components/templates/formquery"),
        compFormEdit: () => import("@components/templates/formedit"),
        compLog: () => import("@components/templates/log"),
        compTablelist: () => import("@components/templates/tablelist"),
	},
    data(){
        return {
            type: this.$route.params.type,
            id: this.$route.query.id,
            // jsonItem:this.$route.query.jsonItem,
            formData:{},
            warehouseName:"",
            logList:[],
            datalist:[],
            LogformData: {
				page: 1,
				rows: 100,
				sidx: 'id',
                sord: 'desc',
                "search[EQ_opModel]":'cost',
                "search[EQ_opDataId]":this.$route.query.id,
            },
            warehouseCount:0,
            nextshow:true,
            editshow:false,
            showwarehouse:false,
            loading:false,
        }
    },
    created(){
      this.update()  
    },
    computed:{
        ...mapGetters('diction',['getAllCurrency','getNewWarehouseCodeList','getNewWarehouseIdList']),
        getCostWarehouseList() {
			return {
				initFormData:{
                    groupId: this.id,
				},
				startUp:true,
				ajaxRequest: HttpGetWarehouseList,
			};
		},
        getBase(){
            return [
                {
					label: "成本组名称",
					key: "groupName",
					tag: "vInput",
					required: false,
				},
                {
					label: "成本币种",
					key: "currency",
					tag: "vSelect",
					options: this.getAllCurrency,
					props: {
						filterable: true,
                    },
                    query:this.type!='add'
                },
                {
					label: "备注",
					key: "description",
					tag: "vTextarea",
					required: false,
				},
            ]
        },
        columns(){
            let _this = this;
            let array = [
                {
                    title: "仓库名称",
                    // key:'orgWarehouseCode',
                    render:(h,{row})=>{
                        // console.log(row)
                        const warehouse = this.getNewWarehouseIdList.filter((item) => {
                            return row.orgWarehouseId == item.value
                        })[0] || {};
                        
                        return <div>{warehouse.label}</div>
                    }
                },
                // {
                //     title: "仓库所在国家",
                //     key:'country',
                // },
                {
                    title: '操作',
                    width:200,
                    render(h, { row, index }) {
                        return h('div',[
                            h('Button', {
                                props:{
                                    type:"error",
                                    size:'small'
                                },
                                on: {
                                    click: () => {
                                        _this.comremove(row,index)
                                    }
                                }
                            },'删除')
                        ])
                    }
                }
            ]
            if(this.type == 'query'){
                array.splice(1,1)
            }
            return array
        }
    },
    methods:{
        changePage(){

        },
        update(){
            if(this.querytype){
                this.id = this.activeid
                this.type = this.querytype
            }else{
                this.id = this.$route.query.id
                this.type = this.type
            }
            if(this.type == 'query'){
                HttpSysOpLog(this.LogformData).then(res=>{
                    this.logList = res.data.content
                },err=>{
                    this.$VMessage.error({
                                content: err.message,
                                duration: 30,
                                closable: true
                            });
                })
                this.showwarehouse = true
            }
            if(this.type != 'add'){
                HttpGetCostGroupOne({
                    groupId:this.id
                }).then(res=>{
                    this.formData = res.data
                    this.datalist = res.data.warehouseGroupMapEntityList
                    this.warehouseCount = res.data.warehouseGroupMapEntityList.warehouseCount
                },err=>{
                    this.$VMessage.error({
                                content: err.message,
                                duration: 30,
                                closable: true
                            });
                })
            }
            if(this.type == 'edit'){
                this.editshow = true
                this.showwarehouse = true
            }
        },
        async submit(nexttype){
            const valid = await this.$refs.editform.validate();
			if (!valid) return;
            
            if(this.nextshow == true){
                this.nextshow = false;
            }
            this.loading = true
            HttpSaveCostGroupOne({
                id:this.id,
                orgId:global.SYSID,
                groupName:this.formData.groupName,
                description:this.formData.description,
                currency:this.formData.currency
            }).then(res=>{
                // this.getCostWarehouseList()
                this.id = res.data.id
                // this.$refs.refwarehosue.updateList()
                this.loading = false
                this.$Message.success(res.message);
                if(nexttype=='addtype'){
                    this.showwarehouse = true
                    this.editshow = true
                }else{
                    this.close()
                }
            },err=>{
                this.loading = false
                this.$VMessage.error({
                                content: err.message,
                                duration: 30,
                                closable: true
                            });
            })
        },
        
        addWarehouse(val){
            
            const itemone = this.getNewWarehouseCodeList.find( json=> val == json.value)
            // console.log(itemone)
            HttpAddWarehouseOne({
                orgId:global.SYSID,
                groupId:this.id,
                orgWarehouseId:itemone.attach.id,
                orgWarehouseCode:val,
            }).then(res=>{
                let data = {
                    orgWarehouseCode:val
                }
                // this.id = res.data.id
                this.$Message.success(res.message);
                // if(type!='add'){
                    this.$refs.refwarehosue.updateList()
                // }
            },err=>{
                this.$VMessage.error({
                                content: err.message,
                                duration: 30,
                                closable: true
                            });
            })
            // let data = {
            //     orgWarehouseCode:val,
            //     country:'',
            // }
            // 
        },
        comremove(row,index){
            // console.log(row,'row')
            HttpDeleteWarehouseOne({
                groupId:row.groupId,
                orgWarehouseId:row.orgWarehouseId
            }).then(res=>{
                this.$Message.success(res.message);
                this.$refs.refwarehosue.updateList()
                // console.log(this.$refs.refwarehosue)
            },err=>{
                this.$VMessage.error({
                                content: err.message,
                                duration: 30,
                                closable: true
                            });
            })
        },
        close(){
            this.$router.push({
                name: 'costGroupList',
            })
        },
    }
}
</script>

